import { cmsAxios } from "./config/axiosConfig";

export interface NeedAssistanceItem {
  id: string;
  assistanceQuestion: string;
  assistanceAnswer: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/** GET /cms/need‑assistance/list */
export const fetchNeedAssistanceList = async (): Promise<
  NeedAssistanceItem[]
> => {
  try {
    const { data } = await cmsAxios.get("/cms/need-assistance/list");
    // API returns: { success: boolean, data: NeedAssistanceItem[] }
    if (!data?.success || !Array.isArray(data.data)) {
      throw new Error("Unexpected response structure");
    }
    return data.data;
  } catch (err) {
    console.error("Error fetching need‑assistance list:", err);
    throw new Error(
      "Unable to load the Need Assistance FAQ list. Please try again later."
    );
  }
};

export const createNeedAssistance = async (payload: {
  assistanceQuestion: string;
  assistanceAnswer: string;
  isActive: boolean;
}): Promise<NeedAssistanceItem> => {
  try {
    const { data } = await cmsAxios.post(
      "/cms/need-assistance/create",
      payload
    );
    if (!data?.success || !data.data) {
      throw new Error("Unexpected response structure from create");
    }
    return data.data;
  } catch (err) {
    console.error("Create FAQ error:", err);
    throw new Error("Failed to create FAQ.");
  }
};

export const updateNeedAssistance = async (
  id: string,
  payload: {
    assistanceQuestion: string;
    assistanceAnswer: string;
    isActive: boolean;
  }
): Promise<void> => {
  try {
    const { data } = await cmsAxios.put(`/cms/need-assistance/${id}`, payload);
    if (!data?.success) {
      throw new Error("Update failed");
    }
  } catch (err) {
    console.error("Update FAQ error:", err);
    throw new Error("Failed to update FAQ.");
  }
};
